import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getInfoResponse } from "utils/common";
import { saveUserInfo } from "features/User/userSlice";
import { SERVICE } from "constants/global";
import noticeAPI from "api/noticeAPI";
import entryAPI from "api/entryAPI";
import newAPI from "api/newAPI";
import ModalManager from "features/Entries/components/Modal/ModalManager";

const getEntries = createAsyncThunk(
  "GET_ENTRIES",
  async (_arg, { dispatch, rejectWithValue }) => {
    try {
      const res = await Promise.all([
        entryAPI.getEntry(_arg),
        noticeAPI.getInitNotice({ service: SERVICE }),
        newAPI.getInitNew({ service: SERVICE }),
      ]);
      dispatch(saveUserInfo(getInfoResponse(res[0])));
      if(res[0].sorrypage == '0' && res[1].sorrypage == '0' && res[2].sorrypage == '0') {
        return { 
          entries: [],
          notice: {},
          isInLine: true 
        };
      }
      return {
        entries: res[0].data.entries?.data,
        notice: res[1].message?.notice,
        new: res[2].data?.news,
        isInLine: res[0].data.isInLine,
        isInLineEntry: res[0].sorrypage == '0' ? true : res[0].data.isInLine,
        isInLineNotice: res[1].sorrypage == '0' ? true : res[1].data?.isInLine,
        isInLineNew: res[2].sorrypage == '0' ? true : res[2].data?.isInLine,
      };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const updateEntry = createAsyncThunk(
  "UPDATE_ENTRY",
  async (_arg, { rejectWithValue }) => {
    try {
      let isInLine = false;
      const { data, openFn } = _arg;
      const res = await entryAPI.updateEntry(data);
      if(res?.sorrypage == '0'){
        openFn("");
        return { 
          entries: [],
          status: null,
          message: null,
          isInLine: true 
        };
      }
      return {
        isInLine,
        entries: res.data ? res.data.entries.data : null,
        status: res.status,
        message: res.message ? res.message : null
      };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const submitEntry = createAsyncThunk(
  "POST_ENTRY",
  async (_arg, { rejectWithValue }) => {
    try {
      const res = await entryAPI.postEntrySubmit(_arg);
      return res;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const cancelEntry = createAsyncThunk(
  "CANCEL_ENTRY",
  async (_arg, { rejectWithValue }) => {
    try {
      let isInLine = false;
      const { entry, openFn } = _arg;
      const res = await entryAPI.postEntrySubmit(entry);
      if(res?.sorrypage == '0'){
        openFn("");
        return {
          entries: [],
          isInLine: true
        }
      }else {
        openFn("modal-cancel-success");
      }
      
      return {
        isInLine,
        entries: res.data.entries.data
      };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const setMessageUpdateSuccess = createAsyncThunk(
  "SET_MESSAGE_UPDATE_SUCCESS",
  async (payload) => {
    return payload;
  }
);

const initialState = {
  entries: null,
  message: null,
  noticesInit: null,
  newsInit: null,
  isInLine: false,
  messageUpdate: null,
  messageUpdateSuccess: null,
};

const entrySlice = createSlice({
  name: "entries",
  initialState,
  extraReducers: {
    [getEntries.fulfilled]: (state, action) => {
      state.entries = action.payload.entries;
      state.noticesInit = action.payload.notice;
      state.newsInit = action.payload.new;
      state.isInLine = action.payload.isInLine;
      state.isInLineEntry = action.payload.isInLineEntry;
      state.isInLineNotice = action.payload.isInLineNotice;
      state.isInLineNew = action.payload.isInLineNew;
    },
    [submitEntry.fulfilled]: (state, action) => {
      if(action?.payload?.sorrypage == '0'){
        state.isInLine = true;
      }else if (action?.payload?.status === "fails") {
        state.message = action.payload.message;
      } else {
        state.entries = action.payload.data.entries.data;
        state.message = null;
      }
    },
    [updateEntry.fulfilled]: (state, action) => {
      state.isInLine = action.payload.isInLine;
      if(!action.payload.isInLine){
        if (action?.payload?.status === "fails") {
          state.messageUpdate = action.payload.message;
        } else {
          state.messageUpdateSuccess = true;
          state.entries = action.payload.entries;
        }
      }
    },
    [cancelEntry.fulfilled]: (state, action) => {
      state.message = null;
      state.isInLine = action.payload.isInLine;
      if(!action.payload.isInLine){
        state.entries = action.payload.entries;
      }
    },
    [setMessageUpdateSuccess.fulfilled]: (state, action) => {
      state.messageUpdateSuccess = action.payload;
    }
  },
});

const { reducer } = entrySlice;
export { getEntries, submitEntry, cancelEntry, updateEntry, setMessageUpdateSuccess };
export default reducer;
